'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Pagination = (function (_React$Component) {
    _inherits(Pagination, _React$Component);

    function Pagination(props) {
        _classCallCheck(this, Pagination);

        _get(Object.getPrototypeOf(Pagination.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Pagination';
    }

    _createClass(Pagination, [{
        key: 'renderCount',
        value: function renderCount() {
            var count = '';
            var _props = this.props;
            var currentPage = _props.currentPage;
            var pageSize = _props.pageSize;
            var plural = _props.plural;
            var singular = _props.singular;
            var total = _props.total;

            if (!total) {
                count = 'No ' + (plural || 'records');
            } else if (total > pageSize) {
                var start = pageSize * (currentPage - 1) + 1;
                var end = Math.min(start + pageSize - 1, total);
                count = 'Showing ' + start + ' to ' + end + ' of ' + total;
            } else {
                count = 'Showing ' + total;
                if (total > 1 && plural) {
                    count += ' ' + plural;
                } else if (total === 1 && singular) {
                    count += ' ' + singular;
                }
            }
            return _react2['default'].createElement('div', { className: 'Pagination__count' }, count);
        }
    }, {
        key: 'onPageSelect',
        value: function onPageSelect(i) {
            if (!this.props.onPageSelect) return;
            this.props.onPageSelect(i);
        }
    }, {
        key: 'renderPages',
        value: function renderPages() {
            var _this = this;

            if (this.props.total <= this.props.pageSize) return null;

            var pages = [];
            var _props2 = this.props;
            var currentPage = _props2.currentPage;
            var pageSize = _props2.pageSize;
            var total = _props2.total;
            var limit = _props2.limit;

            var totalPages = Math.ceil(total / pageSize);
            var minPage = 0;
            var maxPage = totalPages;

            if (limit && limit < totalPages) {
                limit = Math.floor(limit / 2);
                minPage = currentPage - limit - 1;
                maxPage = currentPage + limit;

                if (minPage < 0) {
                    maxPage = maxPage - minPage;
                    minPage = 0;
                }

                if (maxPage > totalPages) {
                    minPage = totalPages - 2 * limit - 1;
                    maxPage = totalPages;
                }
            }

            if (minPage > 0) {
                pages.push(_react2['default'].createElement('button', {
                    key: 'page_start',
                    className: 'Pagination__list__item',
                    onClick: function onClick() {
                        return _this.onPageSelect(1);
                    }
                }, '...'));
            }

            var _loop = function _loop(i) {
                var page = i + 1;
                var current = page === currentPage;
                var className = (0, _classnames2['default'])('Pagination__list__item', {
                    'is-selected': current
                });
                /* eslint-disable no-loop-func */
                pages.push(_react2['default'].createElement('button', {
                    key: 'page_' + page,
                    className: className,
                    onClick: function onClick() {
                        return _this.onPageSelect(page);
                    }
                }, page));
                /* eslint-enable */
            };

            for (var i = minPage; i < maxPage; i++) {
                _loop(i);
            }

            if (maxPage < totalPages) {
                pages.push(_react2['default'].createElement('button', {
                    key: 'page_end',
                    className: 'Pagination__list__item',
                    onClick: function onClick() {
                        return _this.onPageSelect(totalPages);
                    }
                }, '...'));
            }

            return _react2['default'].createElement('div', { className: 'Pagination__list' }, pages);
        }
    }, {
        key: 'render',
        value: function render() {
            var className = (0, _classnames2['default'])('Pagination', this.props.className);
            return _react2['default'].createElement('div', { className: className, style: this.props.style }, this.renderCount(), this.renderPages());
        }
    }]);

    return Pagination;
})(_react2['default'].Component);

Pagination.propTypes = {
    className: _propTypes2['default'].string,
    currentPage: _propTypes2['default'].number.isRequired,
    limit: _propTypes2['default'].number,
    onPageSelect: _propTypes2['default'].func,
    pageSize: _propTypes2['default'].number.isRequired,
    plural: _propTypes2['default'].string,
    singular: _propTypes2['default'].string,
    style: _propTypes2['default'].object,
    total: _propTypes2['default'].number.isRequired
};

module.exports = Pagination;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Pagination.js
// module id = 972
// module chunks = 0 1